import $ from "jquery";
import moment from "moment";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import { courseBasicInfo } from "./courseBasicInfo";
import "jquery-mask-plugin";

let _courseFieldInfo;

function init() {
    initDecimalMask();

    if ($("#HasAvailableSites").val() === "True") {
        $("#add-course-button").click(function() {
            getCourseFieldInfo();
        });
    } else {
        $("#add-course-button").prop("disabled", true);
    }

    $("#AddCourseProgramSelect").change(function() {
        const progId = $("#AddCourseProgramSelect").val();
        getCourseTypes(progId).done(function() {
            const courseTypeId = $("#AddCourseTypeSelect").val();
            getCourseLengths(courseTypeId);
        });
    });
    $("#AddCourseTypeSelect").change(function() {
        const courseTypeId = $("#AddCourseTypeSelect").val();
        const programId = $("#AddCourseProgramSelect").val();
        getCourseLengths(courseTypeId);
        getCourseEditions(courseTypeId, programId);
    });
    $("#AddCourseSiteSelect").change(function() {
        const siteId = $("#AddCourseSiteSelect").val();
        getSiteAddress(siteId);
        getCoordinators(siteId);
    });

    $("#AddCourseHostSiteSelect").change(function () {
        const siteId = $("#AddCourseHostSiteSelect").val();
        getSiteAddress(siteId);
        getCoordinators(siteId);
    }); 

    $("#course-submit").click(function() {
        const $form = $(this).closest("form");
        if (validateDates() && validateCourseFees($form) && $form.valid()) {
            forms.showSpinner();
            $("#IsDraft").val("false");
            $("#status-description").val("CRA Pending Chair Approval");
            forms.disableSubmitButton();
            $form.submit();
        }
    });

    $("#save-draft-submit").click(function() {
        const $form = $(this).closest("form");
        if (!validateDates() || !validateCourseFees($form)) {
            return false;
        }
        $("#IsDraft").val("true");
        $("#status-description").val("Draft");
    });

    $("#special-situation-true").click(function() {
        $("#SpecialTypeContainerAdd").css("display", "block");
        $("#SpecialExplanationContainerAdd").css("display", "block");
        getSpecialSituationTypes();
    });

    $("#special-situation-false").click(function() {
        $("#SpecialTypeContainerAdd").css("display", "none");
        $("#SpecialExplanationContainerAdd")
            .css("display", "none")
            .find("textarea")
            .val("");
    });

    $("#addNewCourse").on("hidden.bs.modal", function(e) {
        $(this)
            .find("input:not([type=hidden]),textarea,select")
            .val("")
            .end()
            .find("input[type=checkbox], input[type=radio]")
            .prop("checked", "")
            .end();
        $("#commercial-support-true").prop("checked", true);
        $("#special-situation-false").prop("checked", true);
        $("#private-class-true").prop("checked", true);
        $("#publish-registration-true").prop("checked", true);
    });

    $("#commercial-support-true").click(function() {
        commercialSupportClick();
    });

    $("#commercial-support-false").click(function() {
        commercialSupportClick();
    });
}

function getCourseTypes(programId) {
    if (programId > 0) {
        return $.Deferred(function(def) {
            dataaccess.get({ url: "/Course/GetCourseTypes/" + programId }).done(function(results) {
                let topCourseType = 0;
                $("#AddCourseTypeSelect option")
                    .not(":first")
                    .remove();
                let i;
                topCourseType = results[0].id;
                for (i = 0; i < results.length; i++) {
                    $("#AddCourseTypeSelect").append(
                        "<option value=" +
                            results[i].id +
                            ">" +
                            results[i].description +
                            "</option>"
                    );
                }
                return def.resolve(topCourseType);
            });
        });
    }
}

function getCourseLengths(courseTypeId) {
    if (courseTypeId > 0) {
        dataaccess.get({ url: "/Course/GetCourseLengths/" + courseTypeId }).done(function(results) {
            $("#AddCourseLengthSelect option")
                .not(":first")
                .remove();
            let i;
            for (i = 0; i < results.length; i++) {
                $("#AddCourseLengthSelect").append(
                    "<option value=" +
                        results[i].id +
                        " data-schedule-days='" +
                        results[i].scheduleDays +
                        "'>" +
                        results[i].description +
                        "</option>"
                );
            }
        });
    }
}

function getCoordinators(siteId) {
    $("#ContactPersonSelect option").remove();
    if (siteId > 0) {
        dataaccess
            .get({ url: `/api/Site/GetSiteCoordinatorsBySiteId/${siteId}` })
            .done(function(results) {
                $("#ContactPersonSelect").append("<option value=''></option>");
                for (let i = 0; i < results.length; i++) {
                    $("#ContactPersonSelect").append(
                        "<option value=" +
                            results[i].id +
                            ">" +
                            `${results[i].firstName} ${results[i].lastName}` +
                            "</option>"
                    );
                }
            });
    }
}

function getSpecialSituationTypes() {
    return $.Deferred(function(def) {
        dataaccess.get({ url: "/Course/GetSpecialSituationTypes/" }).done(function(results) {
            $("#SpecialTypeContainerAdd")
                .find("option")
                .remove();
            let i;
            const topSSType = results[0].id;
            for (i = 0; i < results.length; i++) {
                $("#SpecialTypeContainerAdd select").append(
                    "<option value=" + results[i].id + ">" + results[i].description + "</option>"
                );
            }
            return def.resolve(topSSType);
        });
    });
}

function getCourseFieldInfo() {
    if (_courseFieldInfo) {
        initializeForm(_courseFieldInfo);
    }
    dataaccess.get({ url: "/Course/GetCourseFieldInfo/" }).done(function(results) {
        _courseFieldInfo = results;
        initializeForm(_courseFieldInfo);
        $("#course-form").show();
        $("#spinner").hide();
    });
}

function getCourseEditions(courseTypeId, programId) {
    if (courseTypeId > 0 && programId > 0) {
        dataaccess
            .get({
                url:
                    "/Course/GetCourseEditions/CourseType/" + courseTypeId + "/Program/" + programId
            })
            .done(function(results) {
                $("#AddCourseEditionSelect option")
                    .not(":first")
                    .remove();
                let i;
                for (i = 0; i < results.length; i++) {
                    $("#AddCourseEditionSelect").append(
                        "<option value=" +
                            results[i].id +
                            ">" +
                            results[i].description +
                            "</option>"
                    );
                }
            });
    }
}

function initializeForm(results) {
    forms.showSpinner();
    $("#AddCourseSiteSelect option")
        .not(":first")
        .remove();
    $("#AddCourseHostSiteSelect option")
        .not(":first")
        .remove();
    $("#AddTraumaCourseSiteSelect option")
        .not(":first")
        .remove();
    $("#AddCourseEditionSelect option")
        .not(":first")
        .remove();
    $("#AddCourseLengthSelect option")
        .not(":first")
        .remove();
    $("#AddCourseTypeSelect option")
        .not(":first")
        .remove();
    $("#AddCourseProgramSelect option")
        .not(":first")
        .remove();

    $("#SiteAddLine1").empty();
    $("#SiteAddLine2").empty();
    $("#SiteCity").empty();
    $("#SiteState").empty();
    $("#SitePostalCode").empty();
    $("#SiteCity").empty();

    let i;
    for (i = 0; i < results.sites.length; i++) {
        $("#AddCourseSiteSelect").append(
            "<option value=" +
            results.sites[i].id +
            ">" +
            results.sites[i].description +
            "</option>"
        );
        $("#AddTraumaCourseSiteSelect").append(
            "<option value=" +
            results.sites[i].id +
            ">" +
            results.sites[i].description +
            "</option>"
        );
    }

    let ii;
    for (ii = 0; ii < results.hostSites.length; ii++) {
        $("#AddCourseHostSiteSelect").append(
            "<option value=" +
            results.hostSites[ii].id +
            ">" +
            results.hostSites[ii].description +
            "</option>"
        );
    }

    let j;
    for (j = 0; j < results.courseEditions.length; j++) {
        $("#AddCourseEditionSelect").append(
            "<option value=" +
                results.courseEditions[j].id +
                ">" +
                results.courseEditions[j].description +
                "</option>"
        );
    }

    let k;
    for (k = 0; k < results.courseLengths.length; k++) {
        $("#AddCourseLengthSelect").append(
            "<option value=" +
                results.courseLengths[k].id +
                ">" +
                results.courseLengths[k].description +
                "</option>"
        );
    }

    let l;
    for (l = 0; l < results.courseTypes.length; l++) {
        $("#AddCourseTypeSelect").append(
            "<option value=" +
                results.courseTypes[l].id +
                ">" +
                results.courseTypes[l].description +
                "</option>"
        );
    }

    let m;
    for (m = 0; m < results.programs.length; m++) {
        $("#AddCourseProgramSelect").append(
            "<option value=" +
                results.programs[m].id +
                ">" +
                results.programs[m].description +
                "</option>"
        );
    }

    console.log("SiteId =", $("#AddCourseHostSiteSelect").val());

    if (results.programId === 5) {
        if ($("#AddCourseHostSiteSelect").val() !== "") {
            $("#SiteAddLine1").text(results.hostSites[0].addressLine1);
            $("#SiteAddLine2").text(results.hostSites[0].addressLine2);
            $("#SiteCity").text(results.hostSites[0].city);
            $("#SiteState").text(results.hostSites[0].state.name);
            $("#SiteCountry").text(results.hostSites[0].country.name);
            $("#SitePostalCode").text(results.hostSites[0].postalCode);
        }
    } else {
        if ($("#AddCourseSiteSelect").val() !== "") {
            $("#SiteAddLine1").text(results.sites[0].addressLine1);
            $("#SiteAddLine2").text(results.sites[0].addressLine2);
            $("#SiteCity").text(results.sites[0].city);
            $("#SiteState").text(results.sites[0].state.name);
            $("#SiteCountry").text(results.sites[0].country.name);
            $("#SitePostalCode").text(results.sites[0].postalCode);
        }
    }

    getCourseFees("AddCourseFeesSection");

    forms.hideSpinner();
}

function getCourseFees(resultTargetId, courseId = "") {
    dataaccess.get({ url: "/Course/CourseFees/" + courseId }).done(function(results) {
        $("#" + resultTargetId).html(results);
        initDecimalMask();

        $(document).on("click", "#BtnRemoveCourseFee", function() {
            const $tr = $(this).closest("tr");
            $tr.find("select").val("");
            $tr.find("input[type=text]").val("");
            $tr.find("input[type=hidden]").val("");
        });

        $("#BtnAddCourseFee").click(function() {
            const $tr = $(this)
                .closest("table")
                .find("tbody")
                .find("tr:last");
            const i = parseInt($tr.find("input[type=hidden]").val());
            const iBump = i + 1;
            const $trClone = $tr.clone();
            $trClone.find("select").val("");
            $trClone.find("input[type=text]").val("");
            const nameSelect = $trClone.find("select").attr("name");
            const nameInput = $trClone.find("input[type=text]").attr("name");
            $trClone.find("select").attr("name", nameSelect.replace(i, iBump));
            $trClone.find("input[type=text]").attr("name", nameInput.replace(i, iBump));
            $trClone.find("input[type=hidden]").val(iBump);
            $trClone.insertAfter($tr);
            initDecimalMask();
        });
    });
}

function getOccurrence(array, value) {
    return array.filter(v => v === value).length;
}

function validateCourseFees($form) {
    let isValid = true;
    let message = "";

    const arr = $form.find(".js-course-fees-section select")
        .map(function() {
            if ($(this).val() !== "") {
                return $(this).val();
            }
        })
        .get();

    arr.forEach(function(item) {
        const count = getOccurrence(arr, item);
        if (count > 1) {
            message = "Duplicate categories are not allowed.";
            $("#CourseFeesAlert").text(message);
            isValid = false;
            return false;
        }
    });

    const $trs = $("#CourseFeesSection > table > tbody > tr");

    if (isValid) {
        $trs.each(function() {
            const $tr = $(this);
            const feeType = $tr.find("select").val();
            const regFee = $tr.find("input[type=text]").val();
            if (feeType === "" && regFee !== "") {
                message = "Please verify that each fee has a category assigned.";
                $("#CourseFeesAlert").text(message);
                isValid = false;
                return false;
            } else if ((regFee === "" || regFee < 1) && feeType !== "") {
                message = "Please verify that each category has a fee assigned.";
                $("#CourseFeesAlert").text(message);
                isValid = false;
                return false;
            }
        });
    }

    return isValid;
}

function getSiteAddress(siteId) {
    if (siteId > 0) {
        dataaccess.get({ url: "/api/Site/GetSiteAddress/" + siteId }).done(function(results) {
            $("#SiteAddLine1").empty();
            $("#SiteAddLine2").empty();
            $("#SiteCity").empty();
            $("#SiteState").empty();
            $("#SitePostalCode").empty();
            $("#SiteCity").empty();
            $("#SiteAddLine1").text(results.addressLine1);
            $("#SiteAddLine2").text(results.addressLine2);
            $("#SiteCity").text(results.city);
            if (results.state !== null) {
                $("#SiteState").text(results.state.name);
            }
            $("#SiteCountry").text(results.country.name);
            $("#SitePostalCode").text(results.postalCode);
        });
    }
}

function validateDates() {
    if ($("#StartDateUtc").val() === "" || $("#EndDateUtc").val() === "") {
        return true;
    }

    const startDate = moment(new Date($("#StartDateUtc").val()));
    const endDate = moment(new Date($("#EndDateUtc").val()));
    const calendarDays = endDate.diff(startDate, "days") + 1;
    const scheduleDays = $("#AddCourseLengthSelect option:selected").data("schedule-days");

    if (calendarDays === scheduleDays) {
        $("#ScheduleDaysValidation").hide();
        return true;
    } else {
        $("#ScheduleDaysValidation").show();
        return false;
    }
}

function commercialSupportClick() {
    if ($("[name=CommercialSupport]:checked").val() === "true") {
        courseBasicInfo.showCommercialSupportAlert();
    }
}

function initDecimalMask() {
    $(".js-mask-decimal").mask("0999999.99");
}

export const addCourse = {
    init: init,
    getCourseFees: getCourseFees,
    validateCourseFees: validateCourseFees
};
